import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { client } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(m[1]);

    (async () => {
      try {
        const r = await client.post("/auth/session", { session_id });
        // Also persist token for native-friendly bearer auth (PWA edge cases)
        if (r.data.session_token) {
          localStorage.setItem("session_token", r.data.session_token);
        }

        // For brand-new Google signups, auto-seed the demo workspace so
        // the dashboard is immediately rich (per launch-prep checklist #2).
        if (r.data.is_new_user) {
          try {
            await client.post("/demo/seed", {});
          } catch { /* non-blocking */ }
        }

        setUser(r.data.user);
        // strip hash and route
        window.history.replaceState({}, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: r.data.user } });
      } catch (err) {
        console.error("Auth callback failed", err);
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center text-neutral-400">
      <div className="font-mono text-xs uppercase tracking-[0.3em]">Signing you in…</div>
    </div>
  );
}
